<!--  -->
<template>
  <div class="sdwrw">
    <div class="serch_box">
      <div class="search_box">
        <el-input v-model="query.keywords" clearable style="width:200px;" placeholder="请输入标题或推送编码" />
        <el-select v-model="query.onlyMe" placeholder="请选择">
          <el-option
            v-for="item in accountarr"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
        <el-select v-model="query.admin_id" placeholder="请选择管理员">
          <el-option
            v-for="item in adoptions"
            :key="item.admin_id"
            :label="item.admin_name"
            :value="item.admin_id"
          />
        </el-select>
        <el-button type="primary" icon="el-icon-search" @click="searchclick">搜索</el-button>
        <el-button type="info" icon="el-icon-refresh-right" @click="rechargeclick">重置</el-button>
      </div>
      <div>
        <el-button icon="el-icon-circle-plus" type="success" @click="add">新增</el-button>
      </div>
    </div>
    <el-table
      border
      :data="templatedata"
      style="width: 100%"
    >
      <el-table-column
        prop="title"
        label="标题"
        align="center"
      />
      <el-table-column
        prop="push_no"
        label="推送编号"
        width="240"
        align="center"
      />
      <el-table-column
        prop="template_title"
        label="模板标题"
        align="center"
      />
      <!-- <el-table-column
        prop="send_type_text"
        label="发送类型"
        align="center"
      /> -->
      <el-table-column
        prop="jump_type_text"
        label="跳转类型"
        align="center"
      />
      <el-table-column
        prop="send_time_text"
        label="发送时间"
        align="center"
      />
      <el-table-column
        align="center"
        prop="realName"
        label="创建人"
      />
      <el-table-column
        align="center"
        prop="created_at_text"
        label="创建时间"
      />
      <el-table-column
        label="操作"
        width="260"
        align="center"
      >
        <template slot-scope="scope">
          <el-button type="primary" size="small" @click="task(scope.row)">推送任务</el-button>
          <el-button v-if="scope.row.can_stop_flag" type="warning" size="small" @click="stoptask(scope.row)">停止推送</el-button>
          <el-button type="success" size="small" @click="look(scope.row)">查看</el-button>
          <!-- <el-button v-if="scope.row.can_stop_flag&&show" type="warning" size="small" @click="stoptask(scope.row)">停止推送</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :current-page="query.page"
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      :title="type === 2 ? '查看模板' : '新增模板'"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <creatTemplate ref="creatTemplateview" @creatsuccessclose="creatsuccessclose" />
    </el-dialog>
    <el-dialog
      title="推送任务的详情"
      :visible.sync="taskVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <pushTask ref="taskview" />
    </el-dialog>
  </div>
</template>

<script>
import { list, stopSendPush } from '@/api/numberTemplatemessage.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import creatTemplate from './components/creatTemplate.vue'
import pushTask from './components/pushtask.vue'
import { getadminlist } from '@/api/sourceMaterial.js'
export default {
  components: { PaginationRight, creatTemplate, pushTask },
  data() {
    return {
      query: {
        page: 1,
        page_size: 10,
        keywords: '',
        onlyMe: 2,
        admin_id: null
      },
      total: null,
      templatedata: [],
      dialogVisible: false,
      accountarr: [{
        value: 1,
        label: '查看组内单号模板消息'
      }, {
        value: 2,
        label: '我关联的单号模板消息'
      }],
      taskVisible: false,
      id: '',
      ids: '',
      show: true,
      adoptions: [],
      type: null
    }
  },
  created() {
    this.List()
    this.adminlist()
  },
  mounted() {

  },
  methods: {
    async adminlist() {
      const data = await getadminlist()
      this.adoptions = data.data.list
      console.log('data', data)
    },
    async List() {
      const data = await list(this.query)
      this.templatedata = data.data.list
      this.total = data.data.total
      console.log('this.templatedata', data, this.templatedata)
    },
    // 分页
    fetchPageSize(e) {
      this.query.page_size = e
      this.List()
    },
    fetchCurrentPage(e) {
      this.query.page = e
      this.List()
    },
    searchclick() {
      this.query.page = 1
      this.List()
    },
    rechargeclick() {
      this.query.page = 1
      this.query.keywords = ''
      this.query.admin_id = null
      this.List()
    },
    add() {
      this.type = 1
      this.dialogVisible = true
    },
    creatsuccessclose() {
      console.log('111')
      this.dialogVisible = false
      this.List()
    },
    task(row) {
      console.log('scope.row', row.id)
      this.id = row.id
      this.taskVisible = true
      setTimeout(() => { // 加定时器原因是，子组件页面未渲染处理就做子组件的请求导致失败，稍微延时一下就可解决问题
        this.$refs.taskview.send(this.id)
      }, 100)
    },
    stoptask(row) {
      this.ids = row.id
      console.log('scope.row', row.id)
      this.$confirm('确定要停止推送吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(async() => {
        const datas = await stopSendPush({ id: this.ids })
        console.log('datas---', datas)
        if (datas.code === 200) {
          this.$message({
            type: 'success',
            message: '已停止!'
          })
          this.show = false
          this.List()
        }
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消停止'
        })
      })
    },
    look(item) {
      console.log(item)
      this.dialogVisible = true
      this.type = 2
      this.$nextTick(() => {
        this.$refs.creatTemplateview.edit(item, 2)
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.sdwrw{
  padding: 30px;
}
.serch_box{
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  justify-content: space-between;
}
.search_box{
  display:flex;
  gap:10px;
}

</style>
